import { getDefaultMargin } from '../utils'

export const RatingDesignSettings = {
  'rating-design-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'rating-design-size': {
    phone: 'md',
    'phone-landscape': 'md',
    tablet: 'md',
    'tablet-landscape': 'md',
    desktop: 'md',
    tv: 'md',
  },
  'rating-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
  'rating-design-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'rating-design-color-solid': {
    light: 'primary-20',
    dark: 'primary-20',
  },
}
